export const endpoints = {
  membersLimit(limit: number, page: number) {
    return this.members + `?limit=${limit}&page=${page}`;
  },

  forgotPassword: '/dfaworld/reset-password', // done
  setPassword: '/api/set-password',
  members: '/api/members', // not use
  authenticate: '/api/v1/dfa/authenticate', // done
  user: '/api/user',
  quickRegistrationForm: '/api/registration', // not use
  membersQuantity: '/dfaworld/common-statistic', // done
  contactForm: 'api/contact-form', // not use
  formDemo: '/leads/cargoes-finance-demo', // done
  contact: '/contact/form', // done
  checkResetToken: '/api/check-reset-token', // done
  // for lead form on Benefits pages:
  leadsForm: '/leads/dfa-lead-form',

  feedback: {
    expectations: '/dfaworld/set-expectations-survey',
    experience: '/dfaworld/set-experience-survey',
  },

  signUp: {
    // new sign up
    validatePhone: '/api/v1/dfa/validate-phone', // done
    checkExistingEmail: '/api/v1/dfa/check-existing-email', //done
    submitRegistration: '/api/v1/dfa/submit-registration', // done
    sendVerifyPhoneCode: '/api/v1/dfa/send-phone-code', // done

    // old sign up
    emailValidation: '/api/request-email-validation',
    pinCodeCheck: '/api/check-email-pin-code',
    registration: '/api/quick-registration',
  },

  directory: {
    filter: '/api/v1/dfa/aggregate-cities', // done
    members: '/api/v1/dfa/members-list', // done
  },

  vo: {
    getLoginLink: '/api/v1/profile/get-login-link',
  },

  survey: {
    configSlug: '/api/v1/survey/config',
    tags: '/api/v1/survey/tags',
    save: '/api/v1/survey/answer',
  },

  blacklist: {
    // GET      /api/v1/dfa/blacklist-item?id=1                     - get one

    // Companies:
    getAllCompanies: '/api/v1/dfa/blacklist', // done
    getOneCompany: (companyQuery: string) => `/api/v1/dfa/blacklist-search-company?query=${companyQuery}`, // done
    addNewCompany: '/api/v1/dfa/blacklist-item', // done
    editCompany: `/api/v1/dfa/blacklist-item`,
    removeCompany: (companyId: number | null) => `/api/v1/dfa/blacklist-item?id=${companyId}`, // done

    // Countries:
    getAllCountries: '/api/v1/dfa/country-list', // done

    // Managers:
    getAllManagers: '/api/v1/dfa/blacklist-managers', // done

    // Cities:
    getCities: (countryCode: string) => `/api/v1/dfa/get-cities?country_code=${countryCode}`, // done

    // Files:
    removeFile: (fileId: number) => `/api/v1/dfa/blacklist-delete-file?id=${fileId}`, // done
  },

  blog: {
    articles: '/api/v1/dfa-blog/articles', // admin
    article: '/api/v1/dfa-blog/article', // admin
    previewArticles: '/api/v1/dfa-blog/preview-articles',
    authors: '/api/v1/dfa-blog/authors',
    uploadFile: '/api/v1/dfa-blog/upload-image', // admin
    addView: '/api/v1/dfa-blog/add-view',
    addLike: '/api/v1/dfa-blog/add-like',
    recommends: '/api/v1/dfa-blog/recommends',
  },

  help: {
    faqData: '/api/formatted-help?platform=dfa', // done
    catagories: '/api/help-categories?platform=dfa',
    item: '/api/help',
    items: '/api/help-items?platform=dfa',
  },
};
